import * as React from 'react';
import { QuestionDataService } from '../../services';
import { Question } from '../../models';
import { TopNavMenu } from '../navigation/TopNavMenu';
import { TopNavMenuItem } from '../navigation/TopNavMenuItem';
import { NavLink } from 'react-router-dom';
import { EditState, BaseRouteProps } from '../../interfaces';
import { LoadingIndicator } from '../../components';

interface QuestionEditState extends EditState<Question> {
    questions: Question[];
}

export class ScoreTypeView extends React.Component<BaseRouteProps<{ id: number }>, QuestionEditState> {
    private questionDataService = new QuestionDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        this.state = {
            originalEntity: undefined,
            questions: [],
        };
    }

    public componentDidMount() {
        this.questionDataService.get(this.props.match.params.id).then((characteristicGroup: Question) => {
            this.setState({
                originalEntity: characteristicGroup
            });
        });

    }

    public render() {

        if (!this.state.originalEntity) {
            return <LoadingIndicator />;
        }

        return (
            <div>
                <TopNavMenu open={true}>
                    <TopNavMenuItem>
                        <span className="glyphicon glyphicon-plus" />
                    </TopNavMenuItem>
                </TopNavMenu>

                <div className="content-header">
                    <div className="content-container">
                        <NavLink to={'/surveyinstance'}>
                            <span className="glyphicon glyphicon-triangle-left" /> back
                    </NavLink>
                        <h1>Statement View</h1>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <h3>{this.state.originalEntity.name}</h3>

                        <table className="table">
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td />
                                </tr>
                            </thead>
                            <tbody />
                        </table>
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/scoreType/ScoreTypeView.tsx